import { Accordion, AccordionItem } from 'is24-corecss'
import React, { useMemo } from 'react'
import { RealEstateObject } from './RealEstateObject/RealEstateObject'
import { RealEstateObjectAddressTitle } from './RealEstateObjectAddress/RealEstateObjectAddressTitle'
import { ConvertedRealEstate } from '../../../../../../../../@types/real-estate-api-types'
import styles from './ObjectsContainer.module.css'

export type ObjectContainerProps = {
  objects: ConvertedRealEstate[] | undefined
  closeModal: () => void
}

export const ObjectsContainer = ({ objects, closeModal }: ObjectContainerProps): JSX.Element => {
  const groupedObjects = useMemo(() => groupByAddress(objects), [objects])

  if (!groupedObjects || groupedObjects.size === 0) {
    return <></>
  }
  const firsObject = objects?.[0]

  return (
    <div className={`${styles.objectsGroupsContainer}`} data-testid={`object_container_${firsObject?.meta?.id}`}>
      <Accordion className='margin-top-none'>
        {[...groupedObjects.entries()].map(([key, group]) => (
          <AccordionItem
            defaultExpanded
            title={<RealEstateObjectAddressTitle object={group[0]} />}
            key={key}
            titleClassName='border-none'
          >
            <div className={`${styles.objectsContainer} grid grid-flex gutter-vertical-s`}>
              {group.map((object) => (
                <RealEstateObject object={object} key={object.meta.id} closeModal={closeModal} />
              ))}
            </div>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  )
}

function buildAddressKey(object: ConvertedRealEstate): string {
  const {
    listing: { street, postcode, city },
  } = object
  return [street || '', postcode || '', city || ''].join('-')
}

function groupByAddress(data?: ConvertedRealEstate[]): Map<string, ConvertedRealEstate[]> | undefined {
  return data?.reduce((map, item) => {
    const address = buildAddressKey(item)
    const group = map.get(address) || []
    map.set(address, [...group, item])
    return map
  }, new Map<string, ConvertedRealEstate[]>())
}
